import {
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { InfoCard } from '@shared/models';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['./info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, MatIcon, TranslatePipe]
})
export class InfoCardComponent {
  readonly card = input.required<InfoCard>();
}
